/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
function t(t){const a=3.141592653589793,n=.3183098861837907;t.vertex.constants.add("PI","float",a),t.fragment.constants.add("PI","float",a),t.fragment.constants.add("LIGHT_NORMALIZATION","float",n),t.fragment.constants.add("INV_PI","float",n),t.fragment.constants.add("HALF_PI","float",1.570796326794897),t.fragment.constants.add("TWO_PI","float",6.28318530717958)}export{t as PiUtils};
